import React, { useState, useEffect } from 'react';
import { Table, Spinner, Alert } from 'react-bootstrap';
import { getOrdiniByCliente } from '../../services/api';
import { Link } from 'react-router-dom';

function ClienteOrdiniTab({ clienteId }) {
    const [ordini, setOrdini] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchOrdini = async () => {
            try {
                const response = await getOrdiniByCliente(clienteId);
                setOrdini(response.data);
            } catch (err) {
                setError('Errore nel caricamento dello storico ordini.');
            } finally {
                setLoading(false);
            }
        };
        fetchOrdini();
    }, [clienteId]);

    if (loading) return <Spinner animation="border" />;
    if (error) return <Alert variant="danger">{error}</Alert>;

    return (
        <Table striped bordered hover responsive>
            <thead>
                <tr>
                    <th>ID Ordine</th>
                    <th>Data</th>
                    <th>Stato</th>
                    <th>Totale</th>
                    <th>Azioni</th>
                </tr>
            </thead>
            <tbody>
                {ordini.map(ordine => (
                    <tr key={ordine.id}>
                        <td>{ordine.id}</td>
                        <td>{new Date(ordine.data_ordine).toLocaleDateString()}</td>
                        <td>{ordine.stato}</td>
                        <td>{ordine.totale_ordine.toFixed(2)} €</td>
                        <td>
                            <Link to={`/ordini/${ordine.id}`} className="btn btn-primary btn-sm">
                                Dettagli
                            </Link>
                        </td>
                    </tr>
                ))}
            </tbody>
        </Table>
    );
}

export default ClienteOrdiniTab;
